
export default function rentTable() {

  const rentTableButtons = document.querySelectorAll('.js-rent-table-btn');
  const rentTables = document.querySelectorAll('.car-page__aside-table');

  if ( rentTableButtons && rentTables ) {
    for (let btn of rentTableButtons ) {
      btn.addEventListener('click',function(){
        let n = btn.previousElementSibling.value;
  
        for (let table of rentTables ) {
          table.style.display = "none";
        }
  
        rentTables[n-1].style.display = "block";
      });
    }
  }

}